.backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(0, 0, 0, 0.6);
}
.backdropClose {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: default;
}
.panel {
  position: absolute;
  inset: 0 0 0 auto;
  width: min(100%, 24rem);
  padding: var(--sp-5);
  overflow-y: auto;
  background: var(--surface-raised);
  box-shadow: var(--shadow-lg);
  animation: slide var(--dur) var(--ease);
}
@keyframes slide {
  from {
    transform: translateX(100%);
  }
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-6);
}
.logo {
  height: 2rem;
  width: auto;
}
.close {
  width: 2.75rem;
  height: 2.75rem;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: var(--fs-2xl);
  line-height: 1;
}
.group {
  border-top: 1px solid var(--border);
}
.summary {
  padding: var(--sp-4) 0;
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--text-strong);
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: space-between;
}
.summary::-webkit-details-marker {
  display: none;
}
.summary::after {
  content: "+";
  color: var(--accent);
}
.group[open] .summary::after {
  content: "−";
}
.list {
  padding-bottom: var(--sp-3);
}
.link {
  display: block;
  padding: var(--sp-2) var(--sp-3);
  color: var(--text);
  text-decoration: none;
}
.link:hover {
  color: var(--text-strong);
}
.actions {
  display: grid;
  gap: var(--sp-3);
  margin-top: var(--sp-6);
  padding-top: var(--sp-6);
  border-top: 1px solid var(--border);
}
.contact {
  color: var(--text-strong);
  font-weight: 600;
  text-decoration: none;
}
